// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"7bdbec27","288":"64330982","756":"8aedb847","980":"c98441eb"}[chunkId] + ".chunk.js";
};